import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';
import Chip from './Chip';
import { ResultsContext } from '../contexts';

const RecentSearches = ({ preventModalClose }) => {
	const { recentSearches, handleClearHistory, handleClearHistoryNoClose } =
		useContext(ResultsContext);

	const labels = useLabels();

	const clearFunction = preventModalClose
		? handleClearHistoryNoClose
		: handleClearHistory;

	return (
		<div role="group">
			<div
				className={setClassNames([
					'd-flex',
					'justify-content-between',
					'align-items-center'
				])}
			>
				<div
					id="recent-searches-heading"
					className={setClassNames(['mt-0', 'h4', 'text-capitalize'])}
				>
					{labels.get('RECENT_SEARCHES')}
				</div>
				<button
					className={setClassNames([
						'btn',
						'btn-link',
						'p-0',
						'text-danger',
						'font-weight-light',
						'btn-sm'
					])}
					onClick={clearFunction}
					type="button"
					aria-label={labels.get('CLEAR_SEARCH_HISTORY')}
				>
					{labels.get('CLEAR_HISTORY')}
				</button>
			</div>
			{recentSearches?.slice(0, 5).map((recentSearch) => (
				<Chip key={recentSearch.value} recentSearch={recentSearch} />
			))}
		</div>
	);
};

RecentSearches.propTypes = {
	preventModalClose: PropTypes.bool
};
export default React.memo(RecentSearches);
